import axiosInstance from '../axiosInterceptor/axiosInstance'

const getOrgClub = async (orgId, clubId) => {
  const response = await axiosInstance.get(`v1/orgs/${orgId}/clubs/${clubId}`)
  return response?.data
}

export default getOrgClub
